<app-autocomplete *ngIf="!isClientAdminView"
                  [getDataFunction]="searchClientData.bind(this)"
                  [fields]="fields"
                  [(value)]="selectedClientId"
                  [placeholder]="placeholder"
                  [enabled]="!isDisabled"
                  [isFormComponent]="isFormComponent"
                  (touched)="onTouched()"></app-autocomplete>
<span *ngIf="isClientAdminView">{{selectedClientName}}</span>
